import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { PublicPriceList } from '../seo/price-list.config';
import { PriceListService } from './price-list.service';

/**
 * The price list before the page renders, as the blog's resolvers do for the articles: the Prices
 * page prints its numbers in the server-rendered HTML, and the checkout opens with them.
 */
export const priceListResolver: ResolveFn<PublicPriceList | null> = (): Observable<PublicPriceList | null> =>
  inject(PriceListService).get();
